import React from "react";
import { Typography } from "antd";
const { Text, Title } = Typography;

let Blue = ({ children, ...rest }) => {
  return (
    <Text style={{ backgroundColor: "#40E0D0" }} {...rest}>
      {children}
    </Text>
  );
};

let Bold = ({ children, ...rest }) => {
  return (
    <Text strong style={{ color: "black" }} {...rest}>
      {children}
    </Text>
  );
};

let DefaultTitle = ({ children, ...rest }) => (
  <Title level={4} {...rest}>
    {children}
  </Title>
);

export { Blue, Bold, DefaultTitle };
